import {
  required,
  minLength,
  integer,
  between,
} from 'vuelidate/lib/validators';

const salutations = [
  'Mr',
  'Mrs',
  'Ms',
  'Miss',
  'Dr',
  'Master',
  'Madam',
  'Prof',
  'Sir',
  'Lady',
  'Captain',
];

export default {
  name: 'fund-person-entry',
  props: {
    person: {
      type: Object,
    },
  },
  data: () => ({
    newPerson: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      dob: {
        day: '',
        month: '',
        year: '',
      },
      sex: '',
    },
    salutations,
  }),
  computed: {
    buttonText() {
      return this.person ? 'Edit' : 'Add';
    },
    disableButton() {
      return this.$v.newPerson.$invalid;
    },
  },
  methods: {
    dismiss() {
      this.clearPerson();
      this.$emit('close');
    },
    clearPerson() {
      this.newPerson = {
        title: '',
        firstName: '',
        middleName: '',
        lastName: '',
        dob: {
          day: '',
          month: '',
          year: '',
        },
        sex: '',
      };
      this.$v.newPerson.$reset();
    },
    addPerson() {
      this.$v.newPerson.$touch();
      if (this.$v.newPerson.$anyError) {
        console.log('Form errors!');
      } else {
        const dateOfBirth = new Date(
          parseInt(this.newPerson.dob.year, 10),
          parseInt(this.newPerson.dob.month, 10) - 1,
          parseInt(this.newPerson.dob.day, 10),
          12,
          0,
          0,
        );
        this.newPerson.dateOfBirth = dateOfBirth;
        delete this.newPerson.dob;
        this.$emit('person', this.newPerson);
        this.dismiss();
      }
    },
  },
  mounted() {
    this.newPerson = {
      ...this.person,
      dob: {
        day: this.person.dateOfBirth.getDate(),
        month: this.person.dateOfBirth.getMonth() + 1,
        year: this.person.dateOfBirth.getFullYear(),
      },
    };
  },
  validations: {
    newPerson: {
      title: {
        required,
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      dob: {
        day: {
          required,
          integer,
          between: between(1, 31),
        },
        month: {
          required,
          integer,
          between: between(1, 12),
        },
        year: {
          required,
          integer,
          between: between(1800, new Date().getFullYear()),
        },
      },
      sex: {
        required,
      },
    },
  },
};
